module.exports = __webpack_public_path__ + "static/img/ctx-bg.0fe292d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/ctx-bg.png
// module id = s1fS
// module chunks = 96